import React from 'react';
import './styles.css';
import PropTypes from 'prop-types'

const EscalationMatrix = ({
  onClick,
  escalationMatrix
}) => {
  return (
    <div>
      <a href="javascript:void(0)" title="Close" className="closeLoginModal" onClick={onClick}>X</a>
      <div className="escalationsPopup">

      <div className="manage-user-wrp">
        <div className="row payout-header">
          <span className="payout-header-text">Contact Hierarchy for Support and Escalations</span>
        </div>
        <div className="row user-table-content">
          <table className="app-table">
            <thead>
              <tr className="user-list-table-header">
                <th>Business Development</th>
                <th>Mobile Number</th>
                <th>Email ID</th>
                <th>Regional Lead</th>
                <th>Mobile Number</th>
                <th>Bus Business Lead</th>
                <th>Mobile Number</th>
              </tr>
            </thead>
            <tbody>
                {escalationMatrix.map((item, index) => (
                  <tr key={`abc`} className="user-list-table-row">
                    <td>{item['BD']}</td>
                    <td>{item['BD Mobile']}</td>
                    <td>{item['BD Email']}</td>
                    <td>{item['RL']}</td>
                    <td>{item['RL Mobile']}</td>
                    <td>{item['l2']}</td>
                    <td>{item['l2_mobile']}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="row payout-header">
          <span className="payout-header-text">For Payment related queries</span>
        </div>
        <div className="row user-table-content">
          <table className="app-table">
            <thead>
              <tr className="user-list-table-header">
                <th>For Payments</th>
                <th>Mobile Number</th>
                <th>Email ID</th>
              </tr>
            </thead>
            <tbody>
              <tr key={`abc`} className="user-list-table-row">
                <td>Account Manager</td>
                {escalationMatrix && escalationMatrix.length > 0 && escalationMatrix[0]['BD Mobile'] && <td>{escalationMatrix[0]['BD Mobile']}</td>}
                {escalationMatrix && escalationMatrix.length > 0 && escalationMatrix[0]['BD Email'] && <td>{escalationMatrix[0]['BD Email']}</td>}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      </div>
    </div>
  );
};

EscalationMatrix.propTypes = {
  onClick: PropTypes.func.isRequired,
  escalationMatrix: PropTypes.array.isRequired
};

export default EscalationMatrix;
